var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinPrevidenciaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.297,16.102c0,0.328-0.105,0.598-0.316,0.809s-0.48,0.316-0.809,0.316H1.934c-0.305,0-0.568-0.105-0.791-0.316 c-0.223-0.211-0.334-0.48-0.334-0.809V2.039c0-0.375,0.111-0.68,0.334-0.914C1.365,0.891,1.64,0.762,1.969,0.738h14.027 c0.352,0,0.65,0.123,0.896,0.369s0.381,0.545,0.404,0.896v0.035V16.102z M8.684,16.488v-1.441 c-1.594-0.094-2.953-0.727-4.078-1.898s-1.688-2.566-1.688-4.184c0-1.641,0.562-3.047,1.688-4.219s2.484-1.793,4.078-1.863V1.477 h-6.68c-0.258,0.047-0.41,0.234-0.457,0.562v14.062c0,0.258,0.128,0.387,0.387,0.387H8.684z M14.344,8.965 c0-1.477-0.521-2.736-1.564-3.779S10.477,3.621,9,3.621S6.263,4.143,5.221,5.186C4.178,6.229,3.656,7.488,3.656,8.965 s0.521,2.736,1.564,3.779C6.263,13.787,7.523,14.309,9,14.309s2.736-0.521,3.779-1.564S14.344,10.441,14.344,8.965z M9.422,8.613 h2.637v0.773H9.07C8.812,9.387,8.684,9.258,8.684,9V5.238h0.738V8.613z M16.559,2.039c-0.047-0.375-0.246-0.562-0.598-0.562H9.422 v1.406C11.016,3,12.357,3.639,13.447,4.799s1.635,2.549,1.635,4.166c0,1.594-0.545,2.977-1.635,4.148s-2.432,1.816-4.025,1.934 v1.441h6.75c0.258,0,0.387-0.129,0.387-0.387V2.039z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinPrevidenciaIcon);
export default __webpack_public_path__ + "static/media/zeppelin-previdencia-icon.30a13e71.svg";
export { ForwardRef as ReactComponent };